namespace GcnCustomerAccountHelper {
  export function customerAccountsAreEnabled(): boolean {
    return !!gcn.org.customerAccountsScope && !!gcn.menu.settings.get('customerAccountsUsage');
  }
}

export default GcnCustomerAccountHelper;
